/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ReportDashboardLayoutItem } from './ReportDashboardLayoutItem';
import type { ReportPropertyTypeDistributionFilters } from './ReportPropertyTypeDistributionFilters';
import type { ReportWidgetAccentColor } from './ReportWidgetAccentColor';
import type { ReportWidgetValidation } from './ReportWidgetValidation';
/**
 * Persisted property type distribution widget instance.
 */
export type ReportPropertyTypeDistributionWidgetInstance = {
    /**
     * Stable widget instance identifier.
     */
    id: string;
    /**
     * Discriminator for the property type distribution widget.
     */
    kind: ReportPropertyTypeDistributionWidgetInstance.kind;
    /**
     * Optional user-facing title override.
     */
    title?: string;
    /**
     * Optional short badge label shown on the widget card.
     */
    label?: string;
    /**
     * Optional semantic accent color used to tint the widget card and badge.
     */
    color?: ReportWidgetAccentColor;
    /**
     * Saved layout metadata for the widget instance.
     */
    layout: ReportDashboardLayoutItem;
    /**
     * Validation result resolved from the current tenant state.
     */
    validation?: ReportWidgetValidation;
    /**
     * Saved filters for the property type distribution widget.
     */
    filters: ReportPropertyTypeDistributionFilters;
};
export namespace ReportPropertyTypeDistributionWidgetInstance {
    /**
     * Discriminator for the property type distribution widget.
     */
    export enum kind {
        PROPERTY_TYPE_DISTRIBUTION = 'PROPERTY_TYPE_DISTRIBUTION',
    }
}

